module.exports = __webpack_public_path__ + "media/images/arrow-down-de17b26ddecb04dbd073359a7bdaa5f1.svg";